import { render } from "./g-expand-panel.vue?vue&type=template&id=7729418e&ts=true"
import script from "./g-expand-panel.vue?vue&type=script&lang=tsx"
export * from "./g-expand-panel.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__